import { PasswordChangeForm } from '@/account/PasswordChangeForm'

export function AccountPassword() {
  return <PasswordChangeForm />
}
